export default Object.freeze({
  Delay: 'delay',
  DelayUntil: 'delay-until',
  DelayUntilFieldValue: 'delay-until-field-value',
  DelayUntilVariableValue: 'delay-until-variable-value',
});
